import { getWidgets, updateWidget } from '@/api/legacy/dashboards';
import { UPDATE_WIDGET } from '@/store/types/actions';
import { DASHBOARD_WIDGETS } from '@/store/types/getters';
import { WIDGETS_FETCHED } from '@/store/types/mutations';
import dashboardWidgets from './getters/dashboardWidgets';

const getters = {
  [DASHBOARD_WIDGETS]: dashboardWidgets,
};

const mutations = {
  [WIDGETS_FETCHED](state, widgets) {
    state.widgets = widgets;
  },
};

const actions = {
  [UPDATE_WIDGET]({ commit }, data) {
    return updateWidget(data)
      .then(getWidgets)
      .then((widgets) => commit(WIDGETS_FETCHED, widgets));
  },
};

const state = {
  widgets: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
